<template>
	<n-select
		v-model:value="modelValue"
		class="w-auto!"
		:consistent-menu-width="false"
		:options="officeOptions"
		:placeholder="placeholderText"
		:size
		:clearable
		:render-label
	/>
</template>

<script setup lang="ts">
import type { SelectOption } from "naive-ui"
import type { VNodeChild } from "vue"
import type { I18nString } from "@/lang/config"
import { NSelect } from "naive-ui"
import { storeToRefs } from "pinia"
import { computed, h } from "vue"
import { useI18n } from "vue-i18n"
import { useOfficesStore } from "@/stores/offices"
import { getCalendarOfficeColorByIndex } from "@/utils/calendar"

const props = withDefaults(
	defineProps<{
		placeholder?: string
		size?: "small" | "medium" | "large"
		clearable?: boolean
	}>(),
	{
		clearable: true
	}
)

const modelValue = defineModel<number | null>({ default: null })

const { t } = useI18n()
const officesStore = useOfficesStore()
const { list: offices } = storeToRefs(officesStore)

const placeholderText = computed(() => props.placeholder ?? t<I18nString>(`appointments.common.all_offices`))

type OfficeSelectOption = SelectOption & { color: string }

const officeOptions = computed<OfficeSelectOption[]>(() =>
	offices.value.map((office, index) => ({
		label: office.name,
		value: office.id,
		color: getCalendarOfficeColorByIndex(index)
	}))
)

function renderLabel(option: SelectOption): VNodeChild {
	const { color, label } = option as OfficeSelectOption

	return h("span", { class: "inline-flex min-w-0 items-center gap-2" }, [
		h("span", {
			class: "inline-block size-2 shrink-0 rounded-full",
			style: { backgroundColor: color }
		}),
		h("span", { class: "truncate" }, label as string)
	])
}
</script>
